import i18next from "src/i18n/config";
import { makeStyles } from "tss-react/mui";

import { withMetaDescription } from "@navigation/utils/withMetaDescription";

import { PageContainer } from "../shared/components/PageContainer";

import { OrganizationDetailsSection } from "./components/OrganizationDetailsSection/OrganizationDetailsSection";
import { WorkspaceDetailsSection } from "./components/WorkspaceDetailsSection/WorkspaceDetailsSection";
import { WorkspaceSelector } from "./components/WorkspaceSelector/WorkspaceSelector";
import { WorkspaceStatisticsSection } from "./components/WorkspaceStatisticsSection/WorkspaceStatisticsSection";
import { useWorkspacePageAccess } from "./hooks/useWorkspacePageAccess";

const useStyles = makeStyles()((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
    },
}));

function WorkspacesIntroPage() {
    const { workspace, allowedToEditWorkspace } = useWorkspacePageAccess();
    const { classes } = useStyles();

    return (
        <PageContainer fullWidth={false} className={classes.root}>
            <WorkspaceSelector />

            {workspace ? (
                <>
                    <WorkspaceDetailsSection
                        key={`details-${workspace.id}`}
                        workspace={workspace}
                        canEdit={allowedToEditWorkspace}
                    />
                    <WorkspaceStatisticsSection workspace={workspace} />
                    <OrganizationDetailsSection
                        key={`organization-${workspace.id}`}
                        workspace={workspace}
                        canEdit={allowedToEditWorkspace}
                    />
                </>
            ) : null}
        </PageContainer>
    );
}

export default withMetaDescription(WorkspacesIntroPage, {
    title: i18next.t("pages:workspacePage.intro.metaTitle"),
    description: i18next.t("pages:workspacePage.intro.metaDescription"),
});
